module.exports = __webpack_public_path__ + "images/emoji/clock930.0c15fbf6b36f58eaa9e9.png";